(ns machtfit.admin-employees
  (:require [machtfit.employee-rules :refer [aggregate-rules expand-rules]]
            [machtfit.employee-rules-table :refer [employee-rules-table]]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(defn ^:export load [js-data]
  (rf/dispatch [::init (js->clj js-data :keywordize-keys true)]))

(rf/reg-event-db ::init
  (fn [db [_ data]]
    (-> db
        (merge data)
        (update-in [:data :rules] #(-> %
                                       (aggregate-rules :employee-group :employee-groups)
                                       (aggregate-rules :place-of-business :places-of-business))))))

(rf/reg-sub ::managed-employees
  (fn [_ _]
    nil))

(rf/reg-event-fx ::save-rules-admin-employees
  (fn [{:keys [db]} _]
    {:post {:url (get-in db [:io :save-url])
            :csrf-token (get-in db [:io :csrf-token])
            :data (clj->js {:recipients (-> db :data :recipients)
                            :rules (-> db
                                       :data
                                       :rules
                                       (expand-rules :places-of-business :place-of-business)
                                       (expand-rules :employee-groups :employee-group))})
            :on-success #(rf/dispatch [::save-rules-admin-employees-success %])
            :on-error #(rf/dispatch [::save-rules-admin-employees-error])}}))

(rf/reg-event-fx ::save-rules-admin-employees-success
  (fn [_ [_ result]]
    {:redirect {:url (:redirect-url result)}}))

(rf/reg-event-fx ::save-rules-admin-employees-error
  (fn [_ _]
    {:alert {:msg "Das hat leider nicht geklappt. Bitte wende dich an das Produkt-Team."}}))

(rf/reg-event-db ::add-managed-employees-rule
  (fn [db [_ rule]]
    (update-in db [:data :rules] #(conj (if (empty? %) [] %) rule))))

(rf/reg-event-db ::delete-managed-employees-rule
  (fn [db [_ index]]
    (update-in db [:data :rules] utils/delete-at index)))

(rf/reg-event-db ::set-managed-employees-condition
  (fn [db [_ index condition value]]
    (update-in db [:data :rules index :condition]
               #(if (or (and (coll? value) (empty? value)) (nil? value))
                  (dissoc % condition)
                  (assoc % condition value)))))

(defn- save-button []
  [:button {:class ["mf-btn" "mf-btn--primary"]
            :on-click #(rf/dispatch [::save-rules-admin-employees])}
   "Speichern"])

(defn user-detail []
  [:div#admin-employees {:class ["space-y-4"]}
   [:h2 {:class ["text-sm" "font-semibold" "text-gray-800"]}
    "Dieser Admin darf Mitarbeiter verwalten, auf die die folgenden Bedingungen zutreffen:"]
   [employee-rules-table {:id :admin-employees
                          :allow-no-rules? false
                          :rules-must-match-admin-rules? false
                          :rules-sub [:get [:data :rules]]
                          :companies-sub [:get [:data :condition-options :companies]]
                          :places-of-business-sub [:get [:data :condition-options :places-of-business]]
                          :employee-groups-sub [:get [:data :condition-options :employee-groups]]
                          :subsidiaries-sub [:get [:data :condition-options :subsidiaries]]
                          :occupation-groups-sub [:get [:data :condition-options :occupation-groups]]
                          :managed-employees-sub [::managed-employees]
                          :on-delete-rule ::delete-managed-employees-rule
                          :on-add-rule ::add-managed-employees-rule
                          :on-set-rule-condition ::set-managed-employees-condition
                          :places-of-business-selective-intro-text "Der Benutzer darf Mitarbeiter"
                          :places-of-business-selective-outro-text "verwalten."
                          :places-of-business-not-selective-text "an allen (auch zukünftigen) Standorten."
                          :places-of-business-selective-text "nur an ausgewählten Standorten."
                          :employee-groups-selective-intro-text "Der Benutzer darf Mitarbeiter"
                          :employee-groups-selective-outro-text "verwalten."
                          :employee-groups-not-selective-text "aller (auch zukünftiger) Mitarbeitergruppen"
                          :employee-groups-selective-text "nur ausgewählter Mitarbeitergruppen"}]
   [save-button]])
